export default {
  SET_CITIES (state, cities) {
    state.cities = cities
  },
  REMOVE_RECORD (state, itemId) {
    const cityIndex = state.cities.findIndex((u) => u.id === itemId)
    state.cities.splice(cityIndex, 1)
  }
}
